function initXimenaProductPage(productInfo) {
  if (productInfo.dataset.ximenaProductReady === 'true') return;
  productInfo.dataset.ximenaProductReady = 'true';
  const sticky = productInfo.querySelector('[data-product-sticky]');
  if (!sticky) return;

  const stickyAction = sticky.querySelector('[data-product-sticky-action]');
  const stickyPrice = sticky.querySelector('[data-product-sticky-price]');
  const purchase = productInfo.querySelector('.ximena-product-purchase');
  const mobile = window.matchMedia('(max-width: 749px)');
  let primaryAction;
  let primaryAbove = false;

  const sync = () => {
    primaryAction = document.querySelector(sticky.dataset.primaryAction);
    const price = document.querySelector(sticky.dataset.price)?.querySelector('.price');
    if (price && stickyPrice) stickyPrice.innerHTML = price.outerHTML;
    if (primaryAction && stickyAction) {
      stickyAction.disabled = primaryAction.disabled;
      stickyAction.textContent = primaryAction.querySelector('span')?.textContent.trim() || primaryAction.textContent.trim();
    }
    sticky.hidden = !mobile.matches || !primaryAction || primaryAction.disabled || !primaryAbove;
  };

  const actionObserver = new IntersectionObserver(([entry]) => {
    primaryAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    sync();
  });

  primaryAction = document.querySelector(sticky.dataset.primaryAction);
  if (primaryAction) actionObserver.observe(primaryAction);
  if (purchase) {
    new MutationObserver(sync).observe(purchase, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
  mobile.addEventListener('change', sync);
  stickyAction?.addEventListener('click', () => {
    const currentAction = document.querySelector(sticky.dataset.primaryAction);
    if (currentAction && !currentAction.disabled) currentAction.click();
  });
  sync();

  document.querySelectorAll('[data-product-section-nav] a').forEach((link) => {
    link.addEventListener('click', () => {
      const target = document.querySelector(link.hash);
      if (target?.tagName === 'DETAILS') target.open = true;
    });
  });
}

document.querySelectorAll('product-info.ximena-product').forEach(initXimenaProductPage);
